import nookies from 'nookies';

interface Cookies {
  csrfToken: string;
}

export function getCookies(): Cookies {
  const cookies = nookies.get();

  if (Object.keys(cookies).length > 0) {
    return {
      csrfToken: cookies._csrf || '',
    };
  }

  return { csrfToken: '' };
}
